import { render, staticRenderFns } from "./VueDeckGl.vue?vue&type=template&id=4d2b7a13&scoped=true"
import script from "./VueDeckGl.vue?vue&type=script&lang=js"
export * from "./VueDeckGl.vue?vue&type=script&lang=js"
import style0 from "./VueDeckGl.vue?vue&type=style&index=0&id=4d2b7a13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b7a13",
  null
  
)

export default component.exports